import { put, takeEvery, all, fork } from "redux-saga/effects";
import { CRUD_CREATE_SUCCESS, CRUD_UPDATE_SUCCESS, Record } from "react-admin";
import {
  VehicleDto,
  CreateVehicleDto,
  UpdateVehicleDto,
  EldDeviceDto,
} from "../../../data/service-proxies";
import resourceNames from "../../../data/resourceNames";
import {
  createEldAssignedAction,
  createEldCreatedAction,
  createEldUpdatedAction,
} from "../../actions/appData";

export function* eldCrudSaga() {
  yield all([onVehicleOrEldCreateSaga, onVehicleOrEldEditSaga].map(fork));
}

function* onVehicleOrEldCreateSaga() {
  yield takeEvery(CRUD_CREATE_SUCCESS, handleVehicleOrEldCreate);
}

function* onVehicleOrEldEditSaga() {
  yield takeEvery(CRUD_UPDATE_SUCCESS, handleVehicleOrEldUpdate);
}

function handleVehicleOrEldCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  switch (action.meta.resource) {
    case resourceNames.ADMIN_VEHICLES:
      return handleVehicleCreate(action);
    case resourceNames.ADMIN_ELDS:
      return handleEldCreate(action);
  }
}

function handleVehicleOrEldUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any; previousData: any };
  meta: { resource: string; fetchResponse: string };
}) {
  switch (action.meta.resource) {
    case resourceNames.ADMIN_VEHICLES:
      return handleVehicleUpdate(action);
    case resourceNames.ADMIN_ELDS:
      return handleEldUpdate(action);
  }
}

function* handleVehicleCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_VEHICLES) {
    return;
  }

  const createRequest = action.requestPayload.data as CreateVehicleDto;
  if (createRequest.eldDeviceId) {
    yield put(
      createEldAssignedAction({ id: createRequest.eldDeviceId, assigned: true })
    );
  }
}

function* handleEldCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (!isEld(action.payload.data)) {
    return;
  }

  yield put(createEldCreatedAction(action.payload.data));
}

function* handleVehicleUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any; previousData: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_VEHICLES) {
    return;
  }

  if (!isVehicle(action.payload.data)) {
    return;
  }

  const updateRequest = action.requestPayload.data as UpdateVehicleDto;
  const previousData = action.requestPayload.previousData as VehicleDto;
  if (updateRequest.eldDeviceId === previousData.eldDeviceId) {
    return;
  }

  if (updateRequest.eldDeviceId) {
    yield put(
      createEldAssignedAction({ id: updateRequest.eldDeviceId, assigned: true })
    );
  }

  if (previousData.eldDeviceId) {
    yield put(
      createEldAssignedAction({
        id: previousData.eldDeviceId,
        assigned: false,
      })
    );
  }
}

function* handleEldUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any; previousData: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (!isEld(action.payload.data)) {
    return;
  }

  yield put(createEldUpdatedAction(action.payload.data));
}

const isVehicle = (payload: any): payload is VehicleDto => {
  return payload && "odometer" in payload && "vin" in payload;
};

const isEld = (payload: any): payload is EldDeviceDto => {
  return payload && "serialNumber" in payload && "vendor" in payload;
};
